import { useEffect } from 'react';
import { toast } from 'react-toastify';

function defaultGetErrorMessage(error: unknown) {
    if (error instanceof Error) {
        try {
            const parsedError = JSON.parse(error.message);
            return parsedError.message;
        }
        catch (e) {
            return error.message;
        }
    }
    else if (typeof error === 'string') {
        try {
            const parsedError = JSON.parse(error);
            console.log(parsedError);
            return parsedError.message;
        } catch (e) {
            return error;
        }
    }
}

export function useErrorToast<T>(
    error: T,
    getErrorMessage: (error: T) => string = defaultGetErrorMessage
) {
    useEffect(() => {
        if (error) {
            if (getErrorMessage) {
                toast.error(getErrorMessage(error));
                return;
            }
            try {
                const parsedError = JSON.parse(error.toString());
                toast.error(parsedError.message);
            } catch (e) {
                toast.error(error.toString());
            }
        }
    }, [error, getErrorMessage]);
}
